export default {
  loading: 'Chargement...',
  categories: {
    basic: 'Basique',
    object: 'Objets',
    symbol: 'Symboles',
    arrow: 'Flèches',
    flowchart: 'Flowchart',
    animal: 'Animaux',
    game: 'Cartes & Echecs',
    dialog_balloon: 'Dialog balloons',
    electronics: 'Electronique',
    math: 'Mathematiques',
    music: 'Musique',
    misc: 'Divers',
    raphael_1: 'raphaeljs.com set 1',
    raphael_2: 'raphaeljs.com set 2'
  },
  buttons: [
    {
      title: "Bibliothèque d'images"
    }
  ]
};
